// Web: a área de membros vende conteúdo (painel de compra, checkout).
// O padrão (`storeRules.ts`) é fechado; ver o comentário lá.
export const CAN_SELL_CONTENT_IN_APP: boolean = true
